import React from 'react';
import { HOUSING_TYPES_ONBOARDING } from '../../lib/constants';
import { cn } from '../../lib/utils';
interface StepHousingRoomsProps {
  housingType: string;
  rooms: string;
  onChange: (patch: {
    housingType?: string;
    rooms?: string;
  }) => void;
}
const ROOM_OPTIONS = [{
  value: '1',
  label: '1 cameră'
}, {
  value: '2',
  label: '2 camere'
}, {
  value: '3',
  label: '3 camere'
}, {
  value: '4+',
  label: '4+ camere'
}];
export function StepHousingRooms({
  housingType,
  rooms,
  onChange
}: StepHousingRoomsProps) {
  return <div className="animate-in fade-in slide-in-from-bottom-2 duration-300 space-y-10" data-id="element-2550">
      <div data-id="element-2551">
        <h2 className="text-2xl sm:text-3xl font-bold text-light-1 mb-2" data-id="element-2552">
          Ce tip de proprietate e?
        </h2>
        <p className="text-sm text-light-3" data-id="element-2553">Alege configurația.</p>
      </div>

      <PillGroup label="Tip locuință" value={housingType} options={HOUSING_TYPES_ONBOARDING} onChange={v => onChange({
      housingType: v
    })} data-id="element-2554" />

      <PillGroup label="Număr camere" value={rooms} options={ROOM_OPTIONS} onChange={v => onChange({
      rooms: v
    })} data-id="element-2555" />
    </div>;
}
function PillGroup({
  label,
  value,
  options,
  onChange
}: {
  label: string;
  value: string;
  options: {
    value: string;
    label: string;
  }[];
  onChange: (v: string) => void;
}) {
  return <div data-id="element-2556">
      <h3 className="text-xs font-medium text-light-3 uppercase tracking-wider mb-3" data-id="element-2557">
        {label}
      </h3>
      <div className="flex flex-wrap gap-2" data-id="element-2558">
        {options.map(opt => <button key={opt.value} type="button" onClick={() => onChange(opt.value)} className={cn('h-11 px-5 rounded-full text-sm font-medium border transition-colors cursor-pointer', value === opt.value ? 'bg-lime-1 border-lime-1 text-dark-1' : 'bg-dark-2 border-dark-4 text-light-2 hover:border-light-3')} data-id="element-2559">
            {opt.label}
          </button>)}
      </div>
    </div>;
}